
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerStack2 from "../../editor/platform-markers/cave/PlatformMarkerStack2";
import PlatformMarkerPlatMid from "../../editor/platform-markers/cave/PlatformMarkerPlatMid";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import PlatformMarkerPlat from "../../editor/platform-markers/cave/PlatformMarkerPlat";
import PlatformMarkerStack1 from "../../editor/platform-markers/cave/PlatformMarkerStack1";
import TrapMarkerTorch from "../../editor/trap-markers/cave/TrapMarkerTorch";
import PlatformMarkerPillar from "../../editor/platform-markers/cave/PlatformMarkerPillar";
import CheckpointMarker from "../../editor/CheckpointMarker";
import PlatformMarkerPlatLong from "../../editor/platform-markers/cave/PlatformMarkerPlatLong";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveChunkHard3 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? -381.58257912127925, y ?? 178.22467347422582);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 233, 368);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 7295, 368);
    this.add(editor_bounds_right);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 473, 128);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 350, 131);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 613, 131);
    this.add(gemMarker_3);

    // platformMarkerStack2
    const platformMarkerStack2 = new PlatformMarkerStack2(scene, 289, 304);
    this.add(platformMarkerStack2);

    // platformMarkerStack
    const platformMarkerStack = new PlatformMarkerStack2(scene, 661, 304);
    this.add(platformMarkerStack);

    // platformMarkerPlatMid_1
    const platformMarkerPlatMid_1 = new PlatformMarkerPlatMid(scene, 477, 218);
    this.add(platformMarkerPlatMid_1);

    // platformMarkerStack3
    const platformMarkerStack3 = new PlatformMarkerStack3(scene, 1931, 281);
    this.add(platformMarkerStack3);

    // platformMarkerStack_1
    const platformMarkerStack_1 = new PlatformMarkerStack3(scene, 2178, 274);
    this.add(platformMarkerStack_1);

    // platformMarkerCollapsedPillarNormal
    const platformMarkerCollapsedPillarNormal = new PlatformMarkerPlat(scene, 3101, 276);
    this.add(platformMarkerCollapsedPillarNormal);

    // platformMarkerStack1
    const platformMarkerStack1 = new PlatformMarkerStack1(scene, 2715, 331);
    this.add(platformMarkerStack1);

    // platformMarkerStack_2
    const platformMarkerStack_2 = new PlatformMarkerStack1(scene, 3484, 328);
    this.add(platformMarkerStack_2);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 4089, 62);
    this.add(gemMarker);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 3941, 65);
    this.add(gemMarker_4);

    // platformMarkerCollapsedPillarShort_1
    const platformMarkerCollapsedPillarShort_1 = new PlatformMarkerPlat(scene, 4005, 161);
    this.add(platformMarkerCollapsedPillarShort_1);

    // platformMarkerStack_3
    const platformMarkerStack_3 = new PlatformMarkerStack3(scene, 3901, 274);
    this.add(platformMarkerStack_3);

    // platformMarkerStack_4
    const platformMarkerStack_4 = new PlatformMarkerStack3(scene, 4104, 267);
    this.add(platformMarkerStack_4);

    // trapMarkerTorch
    const trapMarkerTorch = new TrapMarkerTorch(scene, 3679, 185);
    this.add(trapMarkerTorch);

    // platformMarkerPillar
    const platformMarkerPillar = new PlatformMarkerPillar(scene, 3682, 298);
    this.add(platformMarkerPillar);

    // platformMarkerStack_8
    const platformMarkerStack_8 = new PlatformMarkerStack3(scene, 4945, 281);
    this.add(platformMarkerStack_8);

    // platformMarkerCollapsedPillarShort_2
    const platformMarkerCollapsedPillarShort_2 = new PlatformMarkerPlat(scene, 4840, 175);
    this.add(platformMarkerCollapsedPillarShort_2);

    // platformMarkerStack_9
    const platformMarkerStack_9 = new PlatformMarkerStack3(scene, 4746, 288);
    this.add(platformMarkerStack_9);

    // platformMarkerStack_11
    const platformMarkerStack_11 = new PlatformMarkerStack1(scene, 5434, 335);
    this.add(platformMarkerStack_11);

    // platformMarkerStack_10
    const platformMarkerStack_10 = new PlatformMarkerStack1(scene, 5359, 335);
    this.add(platformMarkerStack_10);

    // platformMarkerCollapsedPillarShort_4
    const platformMarkerCollapsedPillarShort_4 = new PlatformMarkerPlat(scene, 6880, 186);
    this.add(platformMarkerCollapsedPillarShort_4);

    // platformMarkerStack_12
    const platformMarkerStack_12 = new PlatformMarkerStack3(scene, 6787, 299);
    this.add(platformMarkerStack_12);

    // platformMarkerStack_13
    const platformMarkerStack_13 = new PlatformMarkerStack3(scene, 6972, 292);
    this.add(platformMarkerStack_13);

    // platformMarkerCollapsedPillarNormal_4
    const platformMarkerCollapsedPillarNormal_4 = new PlatformMarkerPlat(scene, 1111, 285);
    this.add(platformMarkerCollapsedPillarNormal_4);

    // platformMarkerStack_16
    const platformMarkerStack_16 = new PlatformMarkerStack1(scene, 1556, 337);
    this.add(platformMarkerStack_16);

    // platformMarkerStack_18
    const platformMarkerStack_18 = new PlatformMarkerStack3(scene, 2430, 277);
    this.add(platformMarkerStack_18);

    // platformMarkerPillar_1
    const platformMarkerPillar_1 = new PlatformMarkerPillar(scene, 4422, 300);
    this.add(platformMarkerPillar_1);

    // trapMarkerTorch_2
    const trapMarkerTorch_2 = new TrapMarkerTorch(scene, 4419, 185);
    this.add(trapMarkerTorch_2);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 4772, 65);
    this.add(gemMarker_14);

    // gemMarker_16
    const gemMarker_16 = new SmallGemMarker(scene, 4919, 65);
    this.add(gemMarker_16);

    // platformMarkerStack_6
    const platformMarkerStack_6 = new PlatformMarkerStack1(scene, 5826, 336);
    this.add(platformMarkerStack_6);

    // platformMarkerStack_7
    const platformMarkerStack_7 = new PlatformMarkerStack1(scene, 6382, 333);
    this.add(platformMarkerStack_7);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 337, 180);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 3936, 115);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 6798, 148);
    this.add(checkpointMarker_2);

    // platformMarkerPlatLong
    const platformMarkerPlatLong = new PlatformMarkerPlatLong(scene, 2176, 171);
    this.add(platformMarkerPlatLong);

    // trapMarkerTorch_1
    const trapMarkerTorch_1 = new TrapMarkerTorch(scene, 2182, 90);
    this.add(trapMarkerTorch_1);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 3028, 185);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 3184, 185);
    this.add(gemMarker_8);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 6818, 103);
    this.add(gemMarker_13);

    // gemMarker_17
    const gemMarker_17 = new SmallGemMarker(scene, 6962, 103);
    this.add(gemMarker_17);

    // trapMarkerTorch_3
    const trapMarkerTorch_3 = new TrapMarkerTorch(scene, 1028, 205);
    this.add(trapMarkerTorch_3);

    // megaGemMarker_5
    const megaGemMarker_5 = new MegaGemMarker(scene, 5828, 256);
    this.add(megaGemMarker_5);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 3485, 249);
    this.add(megaGemMarker);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 2718, 241);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 2406, 69);
    this.add(gemMarker_6);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 1962, 66);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 1560, 213);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 1196, 176);
    this.add(gemMarker_11);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 5358, 241);
    this.add(gemMarker_15);

    // gemMarker_18
    const gemMarker_18 = new SmallGemMarker(scene, 5441, 239);
    this.add(gemMarker_18);

    // gemMarker_19
    const gemMarker_19 = new SmallGemMarker(scene, 6387, 233);
    this.add(gemMarker_19);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
